import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Label } from 'reactstrap';

const CheckboxControl = props => (
  <Label className="custom-control custom-checkbox">
    {props.display && [
      <Field
        key="field"
        component="input"
        id={props.id}
        type="checkbox"
        name={props.name}
        className="custom-control-input"
        disabled={props.disabled}
        onChange={props.onChange}
      />,
      <span key="label" className="custom-control-label">
        {props.label}
      </span>,
    ]}
  </Label>
);

CheckboxControl.propTypes = {
  disabled: PropTypes.bool,
  display: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
};

CheckboxControl.defaultProps = {
  display: true,
};

export default CheckboxControl;
